import { useRecoilState } from "recoil";
import { openMobileMenu } from "../atoms";
import {
  Collapse,
  Divider,
  IconButton,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import SendIcon from "@mui/icons-material/Send";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import ListIcon from "@mui/icons-material/List";
import styled from "styled-components";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import { useControls } from "react-zoom-pan-pinch";
import ZoomIn from "./menuComponent/ZoomIn";
import ZoomOut from "./menuComponent/ZoomOut";
import ZoomValueInput from "./menuComponent/ZoomValueInput";
import Thumnail from "./menuComponent/Thumnail";
import Contact from "./menuComponent/Contact";
import CenterView from "./menuComponent/CenterView";
import List from "./menuComponent/List";

const Box = styled.div`
  position: fixed;
  top: 60px;
  width: fit-content;
  height: ${(props) => (props.$isOpen ? "270px" : "0px")};
  z-index: 1000;
  background-color: white;
  box-shadow: 1px 5px 5px rgba(0, 0, 0, 0.2);
  transition: 0.2s height ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
`;

function MobileMenu() {
  const [isOpenMobileMenu, setIsOpenMobileMenu] =
    useRecoilState(openMobileMenu);
  const { zoomIn, zoomOut, centerView } = useControls();

  return (
    <Box $isOpen={isOpenMobileMenu}>
      <Collapse in={isOpenMobileMenu}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2,80px)",
            height: "50px",
            marginBottom: "20px",
          }}
        >
          <ZoomOut />
          <ZoomIn />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ZoomValueInput />
        </div>
        <Divider sx={{ margin: "10px 0" }} />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2,1fr)",
            height: "150px",
          }}
        >
          <Thumnail />
          <Contact />
          <CenterView />
          <List />
        </div>
      </Collapse>
    </Box>
  );
}

export default MobileMenu;
